
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profiles/[uri]",
      function () {
        return require("private-next-pages/profiles/[uri]/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profiles/[uri]"])
      });
    }
  